// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2fuL6","savePackageButton":"ClientWallet_savePackageButton__1WyAE"};